// extracted by mini-css-extract-plugin
var _1 = "accept-YROXt";
var _2 = "action-ssJ0g";
var _3 = "button-NsV03";
var _4 = "modalWrapper-XVf8T";
var _5 = "notify-NZ8b_";
var _6 = "notifyBold-eOpVq";
var _7 = "reject-oKlIP";
export { _1 as "accept", _2 as "action", _3 as "button", _4 as "modalWrapper", _5 as "notify", _6 as "notifyBold", _7 as "reject" }
